import { testId } from '../../utils';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import clsx from 'clsx';
import { Check } from 'lucide-react';
import * as React from 'react';

export const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    'data-testid': string;
  }
>(({ className, 'data-testid': dataTestId, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={clsx(
      'block border border-gray-darkest rounded h-4 aspect-square m-1',
      'data-[state=checked]:bg-blue-dark data-[state=checked]:border-blue-dark data-[state=checked]:text-white',
      className,
    )}
    {...testId(dataTestId)}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      {...testId(dataTestId, 'indicator')}
      className={clsx('flex items-center justify-center')}
    >
      <Check
        {...testId(dataTestId, 'check')}
        strokeWidth={4}
        className="h-3 w-3"
      />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = 'Checkbox';
